import request from '@/utils/request'; // ----------------     投保申请单查询接口

export function proposalQueryList(query) {
  return request({
    //  url: '/proposalQuery/proposalQueryList',
    url: '/ecargopolicy/proposalQuery/proposalQueryList',
    method: 'post',
    data: query
  });
} // ----------------     投保申请单删除接口

export function deleteByProposalNo_fun(query) {
  return request({
    //  url: '/proposalQuery/proposalQueryList',
    url: '/ecargopolicy/proposalDelete/deleteByProposalNo',
    method: 'post',
    data: query
  });
} // ----------------     投保申请单撤回接口

export function backByProposalNo_fun(query) {
  return request({
    url: '/ecargopolicy/proposalBack/backByProposalNo',
    method: 'post',
    data: query
  });
} // ----------------    单证注销保单或凭证

export function documentLogOut_fun(query) {
  return request({
    url: '/ecargoapis/documentLogOut/documentLogOutByPolicyNo',
    method: 'post',
    data: query
  });
} // ----------------    批改信息查询

export function correctRecordQuery(query) {
  return request({
    url: '/ecargoapis/correctRecord/query',
    method: 'post',
    data: query
  });
} // ----------------     投保申请单作废接口

export function proposalToVoid_fun(query) {
  return request({
    url: '/ecargopolicy/proposalToVoid/toVoidProposalNo',
    method: 'post',
    data: query
  });
} // --------------       无报关单单条录入初始化页面接口

export function proposalInsertInit(query) {
  return request({
    url: '/ecargopolicy/proposalInsert/proposalInsertInit',
    method: 'post',
    data: query
  });
} // --------------       无报关单单条录入 修改 --浏览接口

export function proposalQueryDto(query) {
  return request({
    url: '/ecargopolicy/proposalQuery/proposalQueryDto',
    method: 'post',
    data: query
  });
} // --------------       浏览操作记录查询接口

export function queryAuditProcessList(query) {
  return request({
    url: '/ecargopolicy/sysAuditrecord/queryAuditProcessList',
    method: 'get',
    params: query
  });
} // --------------       无报关单单条录入 复制 --接口

export function proposalQueryByCopy(query) {
  return request({
    url: '/ecargopolicy/proposalQuery/proposalQueryByCopy',
    method: 'post',
    data: query
  });
} // --------------       无报关单单条录入   校验是否可提交

export function checkOCisBlock(query) {
  return request({
    url: '/ecargopolicy/proposalSaveOrSubmit/checkOCisBlock',
    method: 'post',
    data: query
  });
} // --------------       无报关单单条录入   暂存/提交 接口

export function saveOrSubmit(query) {
  return request({
    url: '/ecargopolicy/proposalSaveOrSubmit/saveOrSubmit',
    method: 'post',
    data: query
  });
} // --------------       批量申报确认接口

export function batchDeclaration(query) {
  return request({
    url: '/ecargopolicy/proposalCall/proposalCallWriteBack',
    method: 'post',
    data: query
  });
} // --------------       协议查询接口

export function findByConditions(query) {
  return request({
    url: '/ecargoprotocol/protocolQuery/findByConditions',
    method: 'post',
    data: query
  });
} // --------------       协议被保险人接口

export function findInsuredByConditions(query) {
  return request({
    url: '/ecargoprotocol/findInsuredByConditions',
    method: 'post',
    data: query
  });
} // --------------       标的货物信息下载获取参数

export function getPath_biaodi(query) {
  return request({
    url: '/ecargopolicy/proposalDownload/getPath',
    method: 'post',
    data: query
  });
} // --------------       标的货物信息下载接口

export function excleCargoDownload_biaodi(query) {
  return request({
    url: '/commondictionary/file/download',
    method: 'get',
    params: query,
    responseType: 'arraybuffer' // responseType: 'blob'

  });
}
export function excleCargoDownload_biaodi1(query) {
  return request({
    url: '/ecargocredit/creditCommon/download',
    method: 'get',
    params: query,
    responseType: 'arraybuffer' // responseType: 'blob'

  });
} // --------------       加成比例与申报基准接口--不要了，和初始化接口合并

/* export function proportion_bonus(query) {
    return request({
        url: '/ecargopolicy/proposalInsert/reqProtocolDto',
        method: 'post',
        data: query
    })
}*/
// --------------       保额保费币种与运输方式 包装接口

export function transport_money(query) {
  return request({
    url: '/ecargoprotocol/protocolQuery/findCodeByProtocol',
    method: 'get',
    params: query
  });
} // --------------       获取自定义标的类型接口

export function markof_type(query) {
  return request({
    url: '/ecargopolicy/item/queryAll',
    method: 'post',
    data: query
  });
} // --------------       匹配责任信息查询接口

export function autoMatchKindInfo_fun(query) {
  return request({
    url: '/ecargopolicy/proposalCheck/autoMatchKindInfo',
    method: 'post',
    data: query
  });
} // --------------       保费计算信息查询接口

export function premiumCalculation_fun(query) {
  return request({
    url: '/ecargopolicy/proposalCheck/premiumCalculation',
    method: 'post',
    data: query
  });
} // --------------       上传影像接口

export function imageUploads_fun(query) {
  return request({
    url: '/ecargopolicy/proposalImageUploads/imageUploads',
    method: 'post',
    data: query,
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    }
  });
} // --------------       影像删除接口

export function imageUploads_del(query) {
  return request({
    url: '/ecargopolicy/proposalImageUploads/imageDel',
    method: 'post',
    data: query //  headers: { 'content-type': 'application/x-www-form-urlencoded' }

  });
} // --------------       理赔影像删除接口

export function imageUploads_dellp(query) {
  return request({
    url: '/ecargopolicy/claim/imageDel',
    method: 'post',
    data: query
  });
} // --------------       影像查看接口

export function imageUploads_view(query) {
  return request({
    url: '/ecargopolicy/proposalImageUploads/imageView',
    method: 'post',
    data: query //  headers: { 'content-type': 'application/x-www-form-urlencoded' }

  });
} // --------------       查询保单自核是否成功接口

export function policyfromcheck_fun(query) {
  return request({
    url: '/ecargopolicy/proposalSaveOrSubmit/queryMain',
    method: 'post',
    data: query //  headers: { 'content-type': 'application/x-www-form-urlencoded' }

  });
} // --------------       保单提交成功后操作         1-申请电子保单，2-申请CI凭证，3-申报

export function proposalCallWriteBack_fun(query) {
  return request({
    url: '/ecargopolicy/proposalCall/proposalCallWriteBack',
    method: 'post',
    data: query //  headers: { 'content-type': 'application/x-www-form-urlencoded' }

  });
} // ----------------      单证预览

export function certificatePreview(query) {
  return request({
    url: '/ecargoapis/smallPolicy/certificatePreview',
    method: 'post',
    data: query,
    responseType: 'blob' //  headers: { 'content-type': 'application/x-www-form-urlencoded' }

  });
} // --------------       点击申请电子保单  后 轮询保单状态接口

export function proposalCallBack_fun(query) {
  return request({
    url: '/ecargopolicy/proposalCall/proposalCallBack',
    method: 'post',
    data: query //  headers: { 'content-type': 'application/x-www-form-urlencoded' }

  });
} // --------------       我已报关接口

export function semiautomatic_mine(query) {
  return request({
    url: '/ecargopolicy/customsProposal/semiautomatic',
    method: 'post',
    data: query //  headers: { 'content-type': 'application/x-www-form-urlencoded' }

  });
} // --------------       船舶 港口数据接口

export function shipInformation_chuan(query) {
  return request({
    url: '/ecargoapis/shipNews/ShipInformation',
    method: 'post',
    data: query //  headers: { 'content-type': 'application/x-www-form-urlencoded' }

  });
} // --------------       船舶 港口数据接口-新

export function newShipInformation(query) {
  return request({
    url: '/ecargoapis/shipNews/newShipInformation',
    method: 'post',
    data: query //  headers: { 'content-type': 'application/x-www-form-urlencoded' }

  });
} // --------------      理赔申请列表查询接口

export function Query_fun(query) {
  return request({
    url: '/ecargopolicy/claim/Query',
    method: 'post',
    data: query //  headers: { 'content-type': 'application/x-www-form-urlencoded' }

  });
} // --------------      理赔申请录入详情接口

export function LookNews_fun(query) {
  return request({
    url: '/ecargopolicy/claim/LookNews',
    method: 'post',
    data: query //  headers: { 'content-type': 'application/x-www-form-urlencoded' }

  });
} // --------------      理赔申请详情提交接口

export function Update_fun(query) {
  return request({
    url: '/ecargopolicy/claim/Update',
    method: 'post',
    data: query //  headers: { 'content-type': 'application/x-www-form-urlencoded' }

  });
} // --------------      理赔上传图片提交接口

export function imageUploads_fun_s(query) {
  return request({
    url: '/ecargopolicy/claim/imageUploads',
    method: 'post',
    data: query,
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    }
  });
}
export function queryByCodeType_fun(query) {
  return request({
    url: '/commondictionary/dictionary/queryByCodeType',
    method: 'post',
    data: query //  headers: { 'content-type': 'application/x-www-form-urlencoded' }

  });
} // 理赔申请查询

export function QueryHistory(query) {
  return request({
    url: '/ecargopolicy/claim/QueryHistory',
    method: 'post',
    data: query //  headers: { 'content-type': 'application/x-www-form-urlencoded' }

  });
} // 理赔申请查看

export function check(query) {
  return request({
    url: '/ecargopolicy/claim/check',
    method: 'post',
    data: query //  headers: { 'content-type': 'application/x-www-form-urlencoded' }

  });
} // b保单申请ocr识别

export function LicenseInfo(data) {
  return request({
    url: '/ecargoapis/business/LicenseInfo',
    method: 'post',
    data: data
  });
} // 赔款确认数据查询

export function reparationConfirmQuery(data) {
  return request({
    url: '/ecargopolicy/claim/reparationConfirmQuery',
    method: 'post',
    data: data
  });
} // 赔款确认操作记录

export function selectClaimLogList(data) {
  return request({
    url: '/ecargopolicy/claim/selectClaimLogList',
    method: 'post',
    data: data
  });
} // 赔款确认操作记录

export function adjustResultOperateTypeUpdate(data) {
  return request({
    url: '/ecargopolicy/claim/adjustResultOperateTypeUpdate',
    method: 'post',
    data: data
  });
} // ----------------------下拉集合
// 保险公司集合

export function findInsuranceCompany() {
  return request({
    url: '/ecargoaccount/user/findInsuranceCompany',
    method: 'get'
  });
} // 分支机构集合

export function companyqueryAll(query) {
  return request({
    url: '/ecargopolicy/company/queryAll',
    method: 'get',
    params: query
  });
} // 产品名称

export function riskqueryAll(query) {
  return request({
    url: '/ecargopolicy/risk/queryAll',
    method: 'get',
    params: query
  });
} // 下拉集合

export function codeTypeList(query) {
  return request({
    url: '/commondictionary/dictionary/codeTypeList',
    method: 'post',
    data: query
  });
} // 城市

export function queryCountry(query) {
  return request({
    url: '/commondictionary/dictionary/queryCountry',
    method: 'post',
    data: query
  });
} // 主附险 责任
// 条款名称 、条款类型

export function clausequeryAll(query) {
  return request({
    url: '/ecargopolicy/clause/queryAll',
    method: 'get',
    params: query
  });
} // 条款新增/修改

export function saveNewClause(data) {
  return request({
    url: '/ecargopolicy/clause/saveNewClause',
    method: 'post',
    data: data
  });
} // 责任查询

export function getKindInfoList(query) {
  return request({
    url: '/ecargopolicy/clause/queryKind',
    method: 'get',
    params: query
  });
} // 特约集合

export function queryEditEngage(query) {
  return request({
    url: '/ecargopolicy/engage/queryEditEngage',
    method: 'get',
    params: query
  });
} //备注特约集合

export function queryRemarkEngage(query) {
  return request({
    url: '/ecargopolicy/engage/queryRemarkEngage',
    method: 'get',
    params: query
  });
}